import { Component, Input } from '@angular/core';

@Component({
  selector: 'studio-dialog-description',
  templateUrl: './dialog-description.component.html',
  styleUrls: ['./dialog-description.component.scss'],
})
export class DialogDescriptionComponent {
  @Input() text: string;
}
